<template>
  <div class="personnel">
    <div class="live">
      <el-row>
        <el-button round type="primary" @click="linkTo()">添加员工</el-button>
        
        <!-- <div class="seach-list r iblock">
          <el-select class="input-v" v-model="search.status" @change="seachStatus">
            <el-option
              v-for="(item,index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            placeholder="搜索员工"
            v-model="search.keywords"
            round
            class="input-with-select input-sea r"
          >
            <el-button slot="append" icon="el-icon-search" @click="seachList()"></el-button>
          </el-input>
        </div> -->
      </el-row>
    </div>
    <!-- //表格数据 -->
    <div class="list-wrap" v-if="resultData.list" v-loading="loading">
      <el-table
        ref="table"
        stripe
        :data="resultData.list"
        :header-cell-style="{backgroundColor:'#f5f7fa'}"
        style="width: 100%;margin: 20px 0;"
      >
        <el-table-column prop="mobile" label="账号"></el-table-column>
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop= "role_name" label="角色">
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-show="scope.row.state==1">启用</span>
            <span v-show="scope.row.state==2">停用</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="添加时间"></el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="edit(scope.row.id)">编辑</el-button>
            <el-button v-if="scope.row.state==1" type="text" size="mini" @click="turnUp(scope.row.id,2)">停用</el-button>
            <el-button v-if="scope.row.state==2||scope.row.state==0" type="text" size="mini" @click="turnDown(scope.row.id,1)">启用</el-button>
            <el-button type="text" size="mini" @click="Delete(scope.row.id,-1)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tc mt20">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="Number(page)"
          :page-size="Number(10)"
          layout="total, prev, pager, next"
          :total="Number(resultData.count)"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { _adminIndex, _adminUpdateState, _adminEdit } from "@/api/admin";

export default {
  created() {
    this.initAdminList();
  },
  data() {
    return {
      loading: false,
      search: {
        keywords: "",
        status: "0"
      },
      course_id: "", //课程id
      options: [
        {
          label: "全部状态",
          value: "0"
        },
        {
          label: "启用",
          value: "1"
        },
        {
          label: "停用",
          value: "2"
        },
      ],
      resultData: [],
      // 翻页信息
      page: "1"
    };
  },
  components: {},
  methods: {
    //加载列表
    initAdminList() {
        this.loading = true;
      _adminIndex({
        params: {
          page: this.page,
          size: 10,
          keywords: this.search.keywords,
          state: this.search.status
        }
      }).then(res => {
        this.loading = false;
        if (res.resultCode == 1) {
          this.resultData = res.result;
        } else {
          tiis.$message.error(res.errorMsg);
        }
      });
    },
    linkTo() {
      let routeData = this.$router.resolve({
        path: "/system/personnel/add"
      });
      window.open(routeData.href, "_blank");
    },
    Delete(id,state) {
      this.$confirm("此操作将删除该员工, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.changeStatus(id,state);
        })
        .catch(() => {});
    },
    //更新用户的状态
    changeStatus(id, state) {
      _adminUpdateState({
        params: {
          id: id,
          state: state
        }
      }).then(res => {
        if (res.resultCode == 1) {
          this.$message.success(res.errorMsg);
          this.initAdminList();
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },

    //状态查询信息
    seachStatus(val) {
      // console.log(val);
      this.initAdminList();
    },
    //关键字查询信息
    seachList() {
      this.initAdminList();
    },
    // 编辑：
    edit(id) {
      let routeData = this.$router.resolve({
        path: `/system/personnel/edit/${id}`
      });
      window.open(routeData.href, "_blank");
    },
    //启用
    turnUp(id,state) {
        this.changeStatus(id,state);
    },
    //停用
    turnDown(id,state) {
        this.changeStatus(id,state);
    },
    //翻页
    handleCurrentChange(val) {
      // console.log(val);
      this.page = val;
      this.initAdminList();
    }
  }
};
</script>

<style scoped lang="less">
.live {
  .seach-list {
    .input-v {
      // width: 160px;
      margin-left: 20px;
    }
    .input-sea {
      margin-left: 20px;
      width: 280px;
      border-radius: 5px;
    }
  }
}
.img_code {
  width: 150px;
  height: 150px;
  border: 1px solid #000;
  margin: 0 auto;
  margin-top: 20px;
  img {
    width: 100%;
  }
}
</style>